import React, { useState, useEffect } from 'react';

interface SimpleCaptchaProps {
  onVerify: (isValid: boolean) => void;
}

const SimpleCaptcha: React.FC<SimpleCaptchaProps> = ({ onVerify }) => {
  const [num1, setNum1] = useState(0);
  const [num2, setNum2] = useState(0);
  const [userAnswer, setUserAnswer] = useState('');
  const [isValid, setIsValid] = useState(false);

  // Generate new math problem
  const generateProblem = () => {
    const a = Math.floor(Math.random() * 10) + 1;
    const b = Math.floor(Math.random() * 10) + 1;
    setNum1(a);
    setNum2(b);
    setUserAnswer('');
    setIsValid(false);
    onVerify(false);
  };

  // Check if answer is correct
  const checkAnswer = (answer: string) => {
    const correctAnswer = num1 + num2;
    const userNum = parseInt(answer);
    
    if (!isNaN(userNum) && userNum === correctAnswer) {
      setIsValid(true);
      onVerify(true);
    } else {
      setIsValid(false);
      onVerify(false);
    }
  };

  // Generate initial problem
  useEffect(() => {
    generateProblem();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAnswerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setUserAnswer(value);
    checkAnswer(value);
  };

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
      <div className="flex items-center space-x-4">
        <div className="flex items-center space-x-2">
          <span className="text-lg font-semibold text-gray-700">
            {num1} + {num2} = ?
          </span>
        </div>
        <input
          type="number"
          value={userAnswer}
          onChange={handleAnswerChange}
          className={`w-20 px-3 py-2 border rounded-lg text-center font-semibold text-gray-900 ${
            userAnswer === '' 
              ? 'border-gray-300' 
              : isValid 
                ? 'border-green-500 bg-green-50' 
                : 'border-red-500 bg-red-50'
          }`}
          placeholder="?"
          min="0"
          max="20"
        />
        {isValid && (
          <div className="text-green-600">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
        )}
        <button
          type="button"
          onClick={generateProblem}
          className="text-blue-600 hover:text-blue-800 text-sm underline"
        >
          New problem
        </button>
      </div>
      <p className="text-xs text-gray-500 mt-2">
        Please solve this simple math problem to verify you're human
      </p>
    </div>
  );
};

export default SimpleCaptcha;
